<template>
    <div>
      <Pos_promotion_detail/>
    </div>
  </template>
  
  <script>
  import Pos_promotion_detail from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_promotion_detail";
  export default {
    name: "PosPromotionDetail",
    components: {
        Pos_promotion_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  